// extracted by mini-css-extract-plugin
module.exports = {"with-no-gutters":"ReceiptVersionList_with-no-gutters__2LemR"};